import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Loginslider from "./Loginslider";
import {
  postSendOTP,
  signUp,
  VerifyUser,
} from "../Service/Auth-Services";
import { useFormik } from "formik";
import * as Yup from "yup";
import LoginLoader from "../../../Shared/Sidebar/LoginLoader";
import { useDataContext } from "../../../Services/Context-Api/Context";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../App";
import { GetMasterBeforeLoginSystemAlert, GetMasterSystemAlert } from "../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import Cookies from "js-cookie";
import { triggerButterflyEffect } from "./ButterflyEffect";

function Login() {
  const [loader, setLoader] = useState(false);
  const [loginPage, setloginPage] = useState("");
  const [playStoreUrl, setPlayStoreUrl] = useState("");
  const [appStoreUrl, setAppStoreUrl] = useState("");
  const [Download_Orggenie_app, setDownload_Orggenie_app] = useState("");
  const [Orggenie_Welcome_heading, setOrggenie_Welcome_heading] = useState("");
  const [Orggenie_Welcome_Action, setOrggenie_Welcome_Action] = useState("");
  const [orgGenie_Legal_Message, setOrgGenie_Legal_Message] = useState("");
  const [orgGenie_Legal_LinkText, setOrgGenie_Legal_LinkText] = useState("");
  const [orgGenie_Legal_URL, setOrgGenie_Legal_URL] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [successful_OTP, setSuccessful_OTP] = useState("");
  const { updateApiData } = useDataContext();
  let history = useHistory();
  const toster = useContext(TostMsg);

  useEffect(() => {
    const savedEmail = Cookies.get("lastLoginEmail");
    if (savedEmail) {
      LoginForm.setFieldValue("UserName", savedEmail);
      setRememberMe(true);
    }
    getMasterSystemBeforeLoginAlertList();
  }, []);
  const LoginValidation = Yup.object().shape({
    UserName: Yup.string() 
      .transform((value) => value.trim())
      .required("Email is required.")
      .email("Email is invalid."),
  });
  const LoginForm = useFormik({
    initialValues: {
      UserName: "",
    },
    validationSchema: LoginValidation,
    onSubmit: async (data) => {
      setLoader(true);
      data.UserName = data.UserName?.toLocaleLowerCase();
      data.AccessToken = "";
      try {
        let verifyUser = await VerifyUser(data);
        if (verifyUser.StatusCode == 2001) {
          await postSendOTP(data);
          toster?.current?.success(successful_OTP);
          await updateApiData(verifyUser?.Data);
          history.push("/Otp");
          if (rememberMe) {
            Cookies.set("lastLoginEmail", data.UserName, { expires: 30 });
          } else {
            Cookies.remove("lastLoginEmail");
          }
        } else {
          await updateApiData({ userName: data.UserName, statusCode: verifyUser.StatusCode });
          history.push("/VerifyUser");
        }
      } catch (error) {
        if (error?.status == 400) {
          // await updateApiData({ userName: data.UserName, statusCode: error.status });
          // history.push("/VerifyUser");
          setLoader(false);
        } else {
          await updateApiData({ userName: data.UserName, statusCode: error.response.data.StatusCode });
          history.push("/VerifyUser");
          setLoader(false);
        }

      }
    },
  });

  const getMasterSystemBeforeLoginAlertList = useCallback(async () => {
    const body = {
      Name: "",
    };
    try {
      let MasterSystemAlert = await GetMasterBeforeLoginSystemAlert(body);
      localStorage?.setItem(
        "SystemAlerts",
        JSON?.stringify(MasterSystemAlert?.Data)
      );
      MasterSystemAlert?.Data?.filter((msg) => {
        if (msg?.Name == "Successful_OTP") {
          setSuccessful_OTP(msg?.Desc);
        } else if (msg?.Name == "PlayStoreUrl") {
          setPlayStoreUrl(msg?.Desc);
        } else if (msg?.Name == "AppStoreUrl") {
          setAppStoreUrl(msg?.Desc);
        } else if (msg?.Name == "Download_Orggenie_app") {
          setDownload_Orggenie_app(msg?.Desc);
        } else if (msg?.Name == "Orggenie_Welcome_heading_web") {
          setOrggenie_Welcome_heading(msg?.Desc);
        } else if (msg?.Name == "Orggenie_Welcome_Action") {
          setOrggenie_Welcome_Action(msg?.Desc);
        } else if (msg?.Name == "OrgGenie_Legal_Message") {
          setOrgGenie_Legal_Message(msg?.Desc);
        } else if (msg?.Name == "OrgGenie_Legal_LinkText") {
          setOrgGenie_Legal_LinkText(msg?.Desc);
        } else if (msg?.Name == "OrgGenie_Legal_URL") {
          setOrgGenie_Legal_URL(msg?.Desc);
        } });
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoader(false);
    }
  }, []);

  const getMasterSystemBeforeLoginAlertLista = useCallback(async () => {
    const body = {
      Name: "",
    };
    try {
      let MasterSystemAlert = await GetMasterSystemAlert(body);
      localStorage?.setItem(
        "SystemAlerts",
        JSON?.stringify(MasterSystemAlert?.Data)
      );
      
      MasterSystemAlert?.Data?.filter((msg) => {
        if (msg?.Name == "Successful_OTP") {
          setSuccessful_OTP(msg?.Desc);
        } else if (msg?.Name == "PlayStoreUrl") {
          setPlayStoreUrl(msg?.Desc);
        } else if (msg?.Name == "AppStoreUrl") {
          setAppStoreUrl(msg?.Desc);
        } else if (msg?.Name == "Download_Orggenie_app") {
          setDownload_Orggenie_app(msg?.Desc);
        } else if (msg?.Name == "Orggenie_Welcome_heading") {
          setOrggenie_Welcome_heading(msg?.Desc);
        }
      });
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoader(false);
    }
  }, []);

  return (
    <>
      <section className="fxt-template-animation fxt-template-layout29 loaded">
        <div className="login-org-logo-area">
          <div className="container">
            <a className="fxt-logo">
              <img
                src="images/login/logo.png"
                alt="Logo"
                className="logo-login"
              />
            </a>
          </div>
        </div>
        <img src="images/login/right.png" className="leftpic" />
        <img src="  images/login/left.png" className="rightpic" />
        <div className="login-org-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6">
                <div className="fxt-content">
                  <div className="fxt-form">
                    <div className="fxt-transformY-50 fxt-transition-delay-1">
                      <h2>
                        Sign in to <b>OrgGenie</b>
                      </h2>
                    </div>
                    <div className="fxt-transformY-50 fxt-transition-delay-2">
                      <p>{Orggenie_Welcome_heading}</p>
                    </div>
                    <form onSubmit={LoginForm.handleSubmit}>
                      <div className="form-group">
                        <div className={"fxt-transformY-50 fxt-transition-delay-4" +
                              (LoginForm.errors.UserName &&
                                LoginForm.touched.UserName
                                ? " is-invalid"
                                : "")} >
                          <input
                            type="text"
                            name="UserName"
                            className={
                              "form-control" 
                            }
                            onChange={(e) => {
                              LoginForm.setFieldValue(
                                "UserName",
                                e.target.value.trimStart()
                              );
                            }}
                            value={LoginForm.values.UserName}
                            placeholder="Email Address"
                            style={{ backgroundImage: "none" }}
                          />
                          <div className="sign-in-icon">
                            <i className="fa fa-envelope-o" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div className="invalid-feedback">
                          {LoginForm.errors.UserName && LoginForm.touched.UserName
                            ? LoginForm.errors.UserName
                            : null}
                        </div>
                        <div class=" form-check pl-3">

                          <input
                            type="checkbox" className="form-check-input"
                            checked={rememberMe}
                            onChange={() => setRememberMe(!rememberMe)}
                          />
                          <label className="form-check-label fs-9">  Remember my email
                          </label>

                        </div>
                      </div>

                      <div className="form-group">
                        <div className="fxt-transformY-50 fxt-transition-delay-6">
                          <div className="fxt-content-between">
                            <button type="submit" className="fxt-btn-fill" onClick={triggerButterflyEffect}>
                              {Orggenie_Welcome_Action} {loader ? <LoginLoader /> : ""}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="fxt-transformY-50 fxt-transition-delay-2">
                      <p className="bottomp">{Download_Orggenie_app}</p>
                      <ul className="app-download">
                        {playStoreUrl && (
                          <li>
                            <a href={playStoreUrl} target="_blank">
                              <img src="images/login/app1.jpeg" />{" "}
                            </a>
                          </li>
                        )}
                        {appStoreUrl && (
                          <li>
                            <a href={appStoreUrl} target="_blank">
                              <img src="images/login/app2.png" />{" "}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                    <p>{orgGenie_Legal_Message} <br /> <a className="fs-9 termcondition-link" href={orgGenie_Legal_URL} target="_blank">{orgGenie_Legal_LinkText}</a></p>
                  </div>
                </div>
              </div>
              <div className="vegas-container col-lg-6  col-md-6">
                <div className="">
                  <img src="/images/login/signup.svg" className="img-fluid" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Login;
